/**
 * 応答に出てくる最小限の Markdown（段落・箇条書き・強調）だけを扱う。
 * ライブラリを入れず、想定外の記法は素のテキストとして表示する方針。
 */
export type Inline = { text: string; strong: boolean };
export type Block = { type: 'p'; parts: Inline[] } | { type: 'ul'; items: Inline[][] };

function parseInline(line: string): Inline[] {
  const parts: Inline[] = [];
  // **強調** のみ対応
  const pattern = /\*\*([^*]+)\*\*/g;
  let cursor = 0;
  let match: RegExpExecArray | null;

  while ((match = pattern.exec(line)) !== null) {
    if (match.index > cursor) parts.push({ text: line.slice(cursor, match.index), strong: false });
    parts.push({ text: match[1], strong: true });
    cursor = match.index + match[0].length;
  }
  if (cursor < line.length) parts.push({ text: line.slice(cursor), strong: false });
  return parts.length ? parts : [{ text: line, strong: false }];
}

export function parseBlocks(markdown: string): Block[] {
  const blocks: Block[] = [];
  let paragraph: string[] = [];
  let listItems: Inline[][] = [];

  const flushParagraph = () => {
    if (paragraph.length) {
      blocks.push({ type: 'p', parts: parseInline(paragraph.join('\n')) });
      paragraph = [];
    }
  };
  const flushList = () => {
    if (listItems.length) {
      blocks.push({ type: 'ul', items: listItems });
      listItems = [];
    }
  };

  for (const rawLine of markdown.split('\n')) {
    const line = rawLine.trimEnd();
    // 「- 項目」「1. 項目」は半角スペース必須。日本語の「・項目」はスペースなしが普通なので許す
    const bullet = /^\s*(?:[-*]\s+|・\s*|\d+[.)]\s+)(.+)$/.exec(line);

    if (bullet) {
      flushParagraph();
      listItems.push(parseInline(bullet[1]));
      continue;
    }
    if (line.trim() === '') {
      flushParagraph();
      flushList();
      continue;
    }
    // 見出しが来た場合は記号だけ落として通常の段落として扱う
    const heading = /^#{1,6}\s+(.*)$/.exec(line);
    flushList();
    paragraph.push(heading ? heading[1] : line);
  }

  flushParagraph();
  flushList();
  return blocks;
}
